import React, { useState, useEffect } from "react";
import SetupScreen from "./components/SetupScreen";
import GameScreen from "./components/GameScreen";
import {
  createGame,
  fetchGame,
  saveActiveGameId,
  loadActiveGameId,
  clearActiveGameId,
} from "./api";

export default function App() {
  const [game, setGame] = useState(null); // { gameId, players, actions }
  const [starting, setStarting] = useState(false);
  const [startError, setStartError] = useState("");
  const [restoring, setRestoring] = useState(true);

  // При завантаженні сторінки перевіряємо, чи є незавершена гра, і якщо є —
  // підвантажуємо її поточний стан з бекенду, замість того щоб показувати SetupScreen.
  useEffect(() => {
    const savedGameId = loadActiveGameId();
    if (!savedGameId) {
      setRestoring(false);
      return;
    }

    fetchGame(savedGameId)
      .then((res) => {
        setGame({
          gameId: res.gameId ?? res.id ?? savedGameId,
          players: res.players || [],
          actions: res.actions || [],
          createdAt: res.created_at ?? res.createdAt ?? null,
        });
      })
      .catch((e) => {
        // Гру не знайдено (напр. вже завершена на бекенді) — забуваємо про неї
        // і повертаємось на екран налаштування.
        console.error(e);
        clearActiveGameId();
      })
      .finally(() => setRestoring(false));
  }, []);

  async function handleStart(players) {
    setStarting(true);
    setStartError("");
    try {
      const payload = players.map((p) => ({ name: p.name, role: p.role }));
      const res = await createGame(payload);

      // Бекенд повертає gameId і, бажано, гравців зі своїми id.
      // Якщо бекенд не повернув players, використовуємо локальні дані як резерв.
      const serverPlayers =
        res?.players?.map((p, i) => ({
          id: p.id ?? players[i].id,
          name: p.name ?? players[i].name,
          role: p.role ?? players[i].role,
          alive: p.alive !== undefined ? p.alive : true,
        })) || players.map((p) => ({ ...p, alive: true }));

      const gameId = res.gameId ?? res.id;
      saveActiveGameId(gameId);
      setGame({
        gameId,
        players: serverPlayers,
        actions: [],
        createdAt: res.created_at ?? res.createdAt ?? new Date().toISOString(),
      });
    } catch (e) {
      setStartError(e.message);
    } finally {
      setStarting(false);
    }
  }

  function handleEndGame() {
    clearActiveGameId();
    setGame(null);
  }

  return (
    <div className="app-shell">
      {restoring ? (
        <p className="eyebrow-mark">Відновлення гри…</p>
      ) : game ? (
        <GameScreen game={game} setGame={setGame} onEndGame={handleEndGame} />
      ) : (
        <SetupScreen onStart={handleStart} starting={starting} startError={startError} />
      )}
    </div>
  );
}
